import * as React from 'react';
import { Route, Switch } from 'react-router';
import { useHistory } from 'react-router-dom';
import Login from './components/login/okta-login';
import OktaLoginCallback from './components/login/okta-login-callback';
import LayoutRouter from './layout-router';
import Paths from './models/enums/paths';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security, SecureRoute } from '@okta/okta-react';
import { oktaAuthConfig } from './shared/okta-config';
import { RestoreOriginalUriFunction } from '@okta/okta-react/bundles/types/OktaContext';
import { useQueryClient } from '@tanstack/react-query';

const oktaAuth = new OktaAuth(oktaAuthConfig);

const Router = () => {
  const history = useHistory();
  const queryClient = useQueryClient();

  const customAuthHandler = () => {
    history.push('/login');
    queryClient.removeQueries();
  };

  const restoreOriginalUri: RestoreOriginalUriFunction = async (_oktaAuth, originalUri) => {
    const url = originalUri || '/';

    history.replace(toRelativeUrl(url, window.location.origin));
  };

  return (
    <Security oktaAuth={oktaAuth} onAuthRequired={customAuthHandler} restoreOriginalUri={restoreOriginalUri}>
      <Switch>
        <Route path={Paths.LoginCallback} component={OktaLoginCallback} />
        <Route path={Paths.Login} exact={true} component={Login} />
        <SecureRoute path="/" exact={false} component={LayoutRouter} />
      </Switch>
    </Security>
  );
};
export default Router;
